import React from "react";
import { TEAL, BENEFITS } from "./constant";
import { useT } from "providers/I18nProvider";

/** Section "Vì sao 1.000++ cơ sở chọn Lookme?" — 6 lợi ích */
const Benefits: React.FC = () => {
  const t = useT();
  return (
    <section className="container mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center max-w-[640px] mx-auto">
        <h2 className="text-[26px] md:text-[32px] font-extrabold text-black01">
          {t("partner.benefitsTitlePrefix")}{" "}
          <span style={{ color: TEAL }}>{t("partner.benefitsTitleHighlight")}</span>{" "}
          {t("partner.benefitsTitleSuffix")}
        </h2>
        <p className="text-gray-600 mt-2">{t("partner.benefitsDesc")}</p>
      </div>
      <div className="mt-6 md:mt-9 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {BENEFITS.map(({ Icon, titleKey, descKey }) => (
          <div
            key={titleKey}
            className="h-full flex flex-col rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md hover:border-primary/30"
          >
            <div className="w-12 h-12 rounded-2xl bg-[#eefbfb] border border-[#d8f3f2] grid place-items-center">
              <Icon size={24} strokeWidth={2.2} style={{ color: TEAL }} aria-hidden="true" />
            </div>
            <h3 className="mt-4 font-extrabold text-black01 text-lg">{t(titleKey)}</h3>
            <p className="text-sm text-gray-600 mt-1.5 leading-relaxed !mb-0">{t(descKey)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefits;
